import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultOptions = {
  elementSeparator: '__',
  modifierSeparator: '--'
};
export function bemJoin() {
  var blockNameOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return typeof blockNameOrOptions === 'string' ? bemJoinOptions(defaultOptions)(blockNameOrOptions) : bemJoinOptions(_objectSpread(_objectSpread({}, defaultOptions), blockNameOrOptions));

  function bemJoinOptions(options) {
    return function (blockName) {
      return function (blockModifiersOrElementName) {
        var elementModifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return (typeof blockModifiersOrElementName === 'string' ? joinBEMModifiers([blockName, blockModifiersOrElementName].join(options.elementSeparator), elementModifiers, options.modifierSeparator) : joinBEMModifiers(blockName, blockModifiersOrElementName, options.modifierSeparator)).join(' ');
      };
    };

    function joinBEMModifiers(blockOrElement) {
      var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var separator = arguments.length > 2 ? arguments[2] : undefined;
      return [blockOrElement].concat(Object.keys(modifiers).filter(function (m) {
        return modifiers[m];
      }).map(function (m) {
        return [blockOrElement, m].join(separator);
      }));
    }
  }
}